import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center mb-2 bg-white rounded-xl border border-gray-300 border-solid" }
const _hoisted_2 = { class: "flex flex-col justify-center w-full rounded-xl" }
const _hoisted_3 = {
  class: "flex justify-between items-center self-stretch my-auto w-5",
  "aria-label": "Toggle expert selection"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col w-full px-6 pb-5 rounded-xl max-md:px-5",
  ref: "collapsible"
}
const _hoisted_6 = { class: "flex flex-col mb-4 mt-4 text-left pb-4" }
const _hoisted_7 = { class: "flex items-center justify-between mb-4 p-4 bg-gray-50 rounded-lg" }
const _hoisted_8 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col mb-2"
}
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_11 = {
  key: 0,
  class: "mt-2 p-2 bg-red-50 rounded-md"
}
const _hoisted_12 = { class: "text-sm text-red-600" }
const _hoisted_13 = {
  key: 1,
  class: "flex flex-col gap-3"
}
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = {
  key: 0,
  class: "mt-2 p-2 bg-red-50 rounded-md"
}
const _hoisted_16 = { class: "text-sm text-red-600" }
const _hoisted_17 = { class: "flex flex-col" }
const _hoisted_18 = {
  key: 0,
  class: "mt-2 p-2 bg-red-50 rounded-md"
}
const _hoisted_19 = { class: "text-sm text-red-600" }
const _hoisted_20 = { class: "flex flex-col" }
const _hoisted_21 = {
  key: 0,
  class: "mt-2 p-2 bg-red-50 rounded-md"
}
const _hoisted_22 = { class: "text-sm text-red-600" }
const _hoisted_23 = {
  key: 1,
  class: "text-sm text-gray-600 bg-blue-50 p-4 rounded-lg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseLabel = _resolveComponent("BaseLabel")!
  const _component_BaseSearchableDropdown = _resolveComponent("BaseSearchableDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "flex gap-10 justify-between items-center px-6 py-5 rounded-xl w-full bg-slate-50 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse && _ctx.toggleCollapse(...args)))
      }, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex items-center gap-2" }, [
          _createElementVNode("div", { class: "flex items-center justify-center w-6 h-6 rounded-full bg-gray-200 text-black font-semibold text-sm" }, " 4 "),
          _createElementVNode("h3", { class: "text-sm font-semibold text-black" }, "Select Experts")
        ], -1)),
        _createElementVNode("button", _hoisted_3, [
          _createElementVNode("div", {
            innerHTML: _ctx.isCollapsed ? _ctx.ARROW_DOWN : _ctx.ARROW_UP
          }, null, 8, _hoisted_4)
        ])
      ]),
      (!_ctx.isCollapsed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex flex-col" }, [
                  _createElementVNode("span", { class: "text-sm font-medium text-gray-900" }, "Pick Random Experts"),
                  _createElementVNode("span", { class: "text-sm text-gray-500" }, "Let the system randomly assign experts to this layout")
                ], -1)),
                _createElementVNode("label", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isRandomMode) = $event)),
                    class: "sr-only peer",
                    onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleRandomModeChange && _ctx.handleRandomModeChange(...args)))
                  }, null, 544), [
                    [_vModelCheckbox, _ctx.isRandomMode]
                  ]),
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-purple/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-purple" }, null, -1))
                ])
              ]),
              (!_ctx.isRandomMode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_BaseLabel, {
                      forAttr: "expertSelector",
                      text: `Choose which expert to display in this layout. ${
                _ctx.layoutType === 'single'
                  ? 'Select one expert for single layout.'
                  : _ctx.layoutType === 'row'
                  ? 'Select up to three experts for row layout.'
                  : 'All experts will be shown in grid layout.'
              }`,
                      class: "font-inter text-sm font-medium leading-normal tracking-normal mb-2"
                    }, null, 8, ["text"]),
                    (_ctx.layoutType === 'single')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_component_BaseSearchableDropdown, {
                            options: 
                  _ctx.approvedExperts.map(
                    (e) =>
                      e.firstName +
                      ' ' +
                      e.lastName +
                      (e.title ? ' - ' + e.title : '')
                  )
                ,
                            modelValue: _ctx.selectedExpertName,
                            onChange: _ctx.handleSingleExpertChange,
                            placeholder: "Select expert"
                          }, null, 8, ["options", "modelValue", "onChange"]),
                          (_ctx.fieldErrors[`${_ctx.layoutId}-0`])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.fieldErrors[`${_ctx.layoutId}-0`]), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.selectedExpertIds.length > 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearAllExperts && _ctx.clearAllExperts(...args))),
                                class: "mt-3 px-4 py-2 text-sm text-red-600 border border-red-600 rounded-md hover:bg-red-600 hover:text-white transition-colors"
                              }, " Clear All "))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.layoutType === 'row')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_BaseLabel, {
                              forAttr: "expert-1",
                              text: "Expert 1",
                              class: "font-inter text-sm font-medium leading-normal tracking-normal mb-1"
                            }),
                            _createVNode(_component_BaseSearchableDropdown, {
                              options: 
                    _ctx.approvedExperts.map(
                      (e) =>
                        e.firstName +
                        ' ' +
                        e.lastName +
                        (e.title ? ' - ' + e.title : '')
                    )
                  ,
                              modelValue: _ctx.getExpertNameById(_ctx.selectedExpertIds[0] || ''),
                              onChange: _cache[4] || (_cache[4] = (name) => _ctx.handleRowExpertChange(0, name)),
                              placeholder: "Select expert 1"
                            }, null, 8, ["options", "modelValue"]),
                            (_ctx.fieldErrors[`${_ctx.layoutId}-0`])
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.fieldErrors[`${_ctx.layoutId}-0`]), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_BaseLabel, {
                              forAttr: "expert-2",
                              text: "Expert 2",
                              class: "font-inter text-sm font-medium leading-normal tracking-normal mb-1"
                            }),
                            _createVNode(_component_BaseSearchableDropdown, {
                              options: 
                    _ctx.approvedExperts.map(
                      (e) =>
                        e.firstName +
                        ' ' +
                        e.lastName +
                        (e.title ? ' - ' + e.title : '')
                    )
                  ,
                              modelValue: _ctx.getExpertNameById(_ctx.selectedExpertIds[1] || ''),
                              onChange: _cache[5] || (_cache[5] = (name) => _ctx.handleRowExpertChange(1, name)),
                              placeholder: "Select expert 2"
                            }, null, 8, ["options", "modelValue"]),
                            (_ctx.fieldErrors[`${_ctx.layoutId}-1`])
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.fieldErrors[`${_ctx.layoutId}-1`]), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_BaseLabel, {
                              forAttr: "expert-3",
                              text: "Expert 3",
                              class: "font-inter text-sm font-medium leading-normal tracking-normal mb-1"
                            }),
                            _createVNode(_component_BaseSearchableDropdown, {
                              options: 
                    _ctx.approvedExperts.map(
                      (e) =>
                        e.firstName +
                        ' ' +
                        e.lastName +
                        (e.title ? ' - ' + e.title : '')
                    )
                  ,
                              modelValue: _ctx.getExpertNameById(_ctx.selectedExpertIds[2] || ''),
                              onChange: _cache[6] || (_cache[6] = (name) => _ctx.handleRowExpertChange(2, name)),
                              placeholder: "Select expert 3"
                            }, null, 8, ["options", "modelValue"]),
                            (_ctx.fieldErrors[`${_ctx.layoutId}-2`])
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.fieldErrors[`${_ctx.layoutId}-2`]), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.selectedExpertIds.length > 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clearAllExperts && _ctx.clearAllExperts(...args))),
                                class: "mt-3 px-4 py-2 text-sm text-red-600 border border-red-600 rounded-md hover:bg-red-600 hover:text-white transition-colors"
                              }, " Clear All "))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_23, " Experts will be randomly assigned to this layout when displayed. "))
            ])
          ], 512))
        : _createCommentVNode("", true)
    ])
  ]))
}